import { UserInfo } from "@/model";
import { Module } from "vuex";

export type StateT = {
  token: string;
  userInfo: UserInfo;
};

const Base: Module<StateT, any> = {
  state: {
    token: "",
    userInfo: {
      id: 0,
      appCode: "",
      loginName: "",
      tenantId: "",
      tenantName: "",
      menuList: [],
      roleMetaList: [],
      userName: "",
      menuNodeList: [],
      allMenuList: [],
    },
  },
  mutations: {
    setToken(state, token: string) {
      state.token = token;
    },
    setUserInfo(state, userInfo: any) {
      state.userInfo = userInfo;
    },
  },
  actions: {},
  modules: {},
};

export default Base;
